module.exports = __webpack_public_path__ + "img/chart-radar.9e9286fa.svg";